import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { REPORT_PRESET } from 'modules/campaigns/modules/campaigns-reports/config/pickers';
import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import { PERFORMANCE_RULE_EXECUTED_ACTIONS_REPORT_ID } from './preformanceRuleActionsReportId';

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_DATE.field,
        FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_RULE_NAME.field,
        FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACCOUNT_NAME.field,
        FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_CAMPAIGN_NAME.field,
        FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACTIVITY.field,
        FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACTIVITY_DETAILS.field,
    ].map(field => generateColumnId(PERFORMANCE_RULE_EXECUTED_ACTIONS_REPORT_ID, field)),
};

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_DATE.field,
    FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_RULE_NAME.field,
    FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACCOUNT_NAME.field,
    FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_CAMPAIGN_NAME.field,
    FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACTIVITY.field,
    FIELDS.PERFORMANCE_RULE_EXECUTED_ACTION_ACTIVITY_DETAILS.field,
].map(field => generateColumnId(PERFORMANCE_RULE_EXECUTED_ACTIONS_REPORT_ID, field));

export { customColumns, defaultColumns };
